export default __webpack_public_path__ + "static/media/cst_500_sal.52c669fb.jpg";